import React from 'react';
import PropTypes from 'prop-types';
import { useDispatch } from 'react-redux';
import { FormattedMessage } from 'react-intl';
import { Modal, Button } from 'ancestry-ui-react';

import { deleteAlert } from '../../ducks/alerts';
import m from './messages';

export default function AlertConfirmDelete({
  itemForDelete,
  setItemForDelete,
}) {
  const dispatch = useDispatch();
  const handleClose = () => setItemForDelete(null);

  const handleDelete = () => {
    dispatch(deleteAlert(itemForDelete));
    handleClose();
  };

  return (
    <Modal
      open={!!itemForDelete}
      onClose={handleClose}
      closeOnBkgClick
      hideCloseBtn
    >
      <div className='alert__modal-body'>
        <FormattedMessage
          {...m.confirm}
          values={{ name: itemForDelete.title }}
        />
      </div>
      <div className='alert__modal-actions'>
        <Button onClick={handleClose} className='ancBtn noBorder cancel'>
          <FormattedMessage {...m.cancel} />
        </Button>
        <Button onClick={handleDelete} className='ancBtn noBorder submit'>
          <FormattedMessage {...m.yes} />
        </Button>
      </div>
    </Modal>
  );
}

AlertConfirmDelete.propTypes = {
  itemForDelete: PropTypes.object.isRequired, // object can be null or object type
  setItemForDelete: PropTypes.func.isRequired,
};
